// extracted by mini-css-extract-plugin
export default {"root":"_1HXnm","link-overlay":"_2bNt_","linkOverlay":"_2bNt_"};